import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRefreshToken, generateRandomString, generateCodeChallenge } from './AuthToken';
import { Loading } from '../../Loading';

declare global {
  interface Window {
    REACT_LOGIN_URL: any;
    REACT_ACCESS_TOKEN_URL: any;
    REACT_REFRESH_TOKEN_URL: any;
  }
}
const Login = (props: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [, setAuthToken] = useAuthToken();
  const [, setRefreshToken] = useRefreshToken();
  let history = useHistory();

  // const code = new RegExp('[?&#]access_token=([^&#]*)').exec(window.location.href);
  const code = new RegExp('[?&#]code=([^&#]*)').exec(window.location.href);
  const state = new RegExp('[?&#]state=([^&#]*)').exec(window.location.href);

  const getAccessToken = (code: any) => {
    const codeVerifier = window.sessionStorage.getItem('code_verifier');
    const accessTokenUrl = `${window.REACT_ACCESS_TOKEN_URL}&code=${code[1]}&code_verifier=${codeVerifier}`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: JSON.stringify({ title: 'Self Service Authorization' })
    };
    fetch(accessTokenUrl, requestOptions)
      .then(response => response.json())
      .then(data => {
        // setAuthToken(data?.access_token);
        localStorage.setItem(window.REACT_ACCESS_TOKEN_URL, data?.access_token);
        localStorage.setItem(window.REACT_REFRESH_TOKEN_URL, data?.refresh_token);
        sessionStorage.removeItem('code_verifier');
        if (state) {
          history.push(decodeURIComponent(state[1]));
        } else {
          history.push('/');
        }
      })
      .catch(e => {
        console.log('error', e);
        window.location.href = window.REACT_LOGIN_URL;
      });
  };

  if (code) {
    getAccessToken(code);
  } else {
    const codeVerifier = generateRandomString(43);
    generateCodeChallenge(codeVerifier).then((codeChallenge: any) => {
      window.sessionStorage.setItem('code_verifier', codeVerifier);
      let loginUrl: any;
      if (props?.location?.state?.search) {
        loginUrl = `${window.REACT_LOGIN_URL}&state=${props?.location?.state?.search}`;
      } else {
        loginUrl = window.REACT_LOGIN_URL;
      }
      window.location.href = `${loginUrl}&code_challenge=${codeChallenge}`;
    });
  }
  return (
    <div className="logout-login">
      <Loading />
      Redirecting to Login...Please wait..
    </div>
  );
};

export default Login;
